import { gql } from "@apollo/client"
import { DEMAND_LIST_FRAG } from "./demand.fragments.gql"
export const ADD_DEMAND = gql`
  mutation CreateDemand(
    $name: String!
    $dateRange: [Date!]!
    $varietyGroup: ID!
    $depot: Int!
    $broadcastTime: DateTime!
    $gradePrices: [BookingGradePriceInput!]!
    $timeSlots: [TimeSlotRequirementInput!]!
    $description: String
    $allowAggregatorVehicle: Boolean
    $allowOwnVehicle: Boolean
    $bookingQuantityLimit: Float
    $companyVisibility: [Int]
    $groupVisibility: [Int]
    $companyId: ID
    $attachments: [MediaInput]
    $shouldConsolidate: Boolean
  ) {
    addDemand(
      name: $name
      dateRange: $dateRange
      varietyGroup: $varietyGroup
      depot: $depot
      broadcastTime: $broadcastTime
      gradePrices: $gradePrices
      timeSlots: $timeSlots
      description: $description
      bookingQuantityLimit: $bookingQuantityLimit
      allowAggregatorVehicle: $allowAggregatorVehicle
      allowOwnVehicle: $allowOwnVehicle
      companyVisibility: $companyVisibility
      groupVisibility: $groupVisibility
      companyId: $companyId
      attachments: $attachments
      shouldConsolidate: $shouldConsolidate
    ) {
      demands {
        ...DemandListFrag
      }
    }
  }
  ${DEMAND_LIST_FRAG}
`

export const UPDATE_BULK_DEMANDS = gql`
  mutation updateBulkDemands(
    $filter: DemandFilterInput
    $ids: [ID]
    $isLive: Boolean
    $name: String
    $query: String
    $description: String
  ) {
    updateBulkDemands(
      filter: $filter
      ids: $ids
      isLive: $isLive
      name: $name
      query: $query
      description: $description
    ) {
      demands {
        id
        isLive
        name
        description
      }
    }
  }
`
